import React from 'react';
import './MoonLoader.css';
import PropTypes from 'prop-types';
import useTheme from '@mui/material/styles/useTheme';

const MoonLoader = ({
  size = 60,
  color,
  loading = true
}) => {
  const theme = useTheme();
  const activeColor = color || theme.palette.primary.main;

  if (!loading) return null;

  // react-spinners MoonLoader logic:
  // ballSize is roughly size / 7
  const thickness = size / 7;

  return (
    <div
      className="moon-loader-wrapper"
      style={{
        width: size,
        height: size,
      }}
      role="status"
      aria-label="Loading"
    >
      <div
        className="moon-loader-ring"
        style={{
          border: `${thickness}px solid rgba(0, 0, 0, 0.1)`, // Light gray track regardless of loader color
          backgroundColor: 'transparent', // Ensure inside is transparent
        }}
      />
      <div
        className="moon-loader-ball"
        style={{
          width: thickness,
          height: thickness,
          backgroundColor: activeColor,
          // Position the ball at the top edge, centered horizontally
          // Since we use border-box for the ring, the "top" of the border is at 0.
          // The ball should sit roughly on top of that border.
        }}
      />
    </div>
  );
};

MoonLoader.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  loading: PropTypes.bool
};

export default MoonLoader;
